import React from 'react';

const AddLinkModal = () => {
	return (
		<div className="popup-wrapper add-link-modal create-design-option-modal">
			<div className="common-popup create-design-option-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">Add link</h3>
					</div>
					<div className="close-btn">
						<img alt="close" src=" /icons/close.svg" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="row">
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Link title</label>
									<input type="text" placeholder="Enter link title" />
								</div>
							</div>
						</div>
						<div className="col-md-12 pr-2">
							<div className="form-group">
								<div className="select-component">
									<label htmlFor="collection">Paste link here</label>
									<input type="text" placeholder="Copy-past your link here" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer pt-0">
					<div className="footer-buttons text-right">
						<button className="button outline size32 ml-2">Cancel</button>
						<button className="button size32 ml-2">Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddLinkModal;
